import { phoneMatchKey } from "./shared";

const BOOK_KEY = "neron_caller_book_v1";

export type CallerBookEntry = { name: string; company?: string };

function readBook(): Record<string, CallerBookEntry> {
  if (typeof window === "undefined") return {};
  try {
    const raw = localStorage.getItem(BOOK_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

function writeBook(book: Record<string, CallerBookEntry>) {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(BOOK_KEY, JSON.stringify(book));
  } catch {
    /* quota / private mode */
  }
}

export function lookupCallerBook(phone: string): CallerBookEntry | null {
  const key = phoneMatchKey(phone);
  if (!key) return null;
  const book = readBook();
  return book[key] || null;
}

export function saveCallerBookEntry(phone: string, name?: string, company?: string) {
  const key = phoneMatchKey(phone);
  if (!key || !name?.trim()) return;
  const book = readBook();
  book[key] = {
    name: name.trim(),
    company: company?.trim() || book[key]?.company || undefined,
  };
  writeBook(book);
}

export function mergeCallerBook(
  rows: Array<{ phone?: string; mobile?: string; name?: string; company?: string }>,
) {
  const book = readBook();
  let changed = false;
  for (const row of rows) {
    const phone = String(row.phone || row.mobile || "");
    const key = phoneMatchKey(phone);
    const name = String(row.name || "").trim();
    if (!key || !name) continue;
    const company = String(row.company || "").trim() || undefined;
    const prev = book[key];
    if (!prev || prev.name !== name || prev.company !== company) {
      book[key] = { name, company: company || prev?.company };
      changed = true;
    }
  }
  if (changed) writeBook(book);
  return book;
}

export function allCallerBookEntries(): Array<{ phone: string; name: string; company?: string }> {
  const book = readBook();
  return Object.entries(book).map(([phone, v]) => ({
    phone,
    name: v.name,
    company: v.company,
  }));
}
